var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonIconPkgLead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01456 6.20852C1.19456 8.78352 3.37956 10.8785 5.99456 10.9935C7.83956 11.0735 9.48956 10.2135 10.4796 8.85852C10.8896 8.30352 10.6696 7.93352 9.98456 8.05852C9.64956 8.11852 9.30456 8.14352 8.94456 8.12852C6.49956 8.02852 4.49956 5.98352 4.48956 3.56852C4.48456 2.91852 4.61956 2.30352 4.86456 1.74352C5.13456 1.12352 4.80956 0.828516 4.18456 1.09352C2.20456 1.92852 0.849557 3.92352 1.01456 6.20852Z",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIconPkgLead);
export default __webpack_public_path__ + "static/media/moon-icon-pkg-lead.8cbf6c7d90d987aefbea8ad47a5a3dd9.svg";
export { ForwardRef as ReactComponent };